__turbopack_context__.v({
  "productTable": "_6cbnuG_productTable",
});
